
const nameMapping = {
    'abnormalReport': { name: '异常上报', unit: '' },
    'cppm': { name: '机舱巡查人员监测', unit: '' },
    'depthGauge': { name: '测深仪', unit: '' },
    'fpblef': { name: '左机滤前燃油压力', unit: 'KPa' },
    'fpbref': { name: '右机滤前燃油压力', unit: 'KPa' },
    'hotrdot': { name: '右日用油柜高度', unit: 'cm' },
    'lbv': { name: '左机电瓶电压', unit: '伏特' },
    'ldoth': { name: '左日用油柜高度', unit: 'cm' },
    'lebap': { name: '左机增压空气压力', unit: 'KPa' },
    'lebat': { name: '左机增压空气温度', unit: '°C' },
    'lefflop': { name: '左机滤前滑油压力', unit: 'KPa' },
    'lefip': { name: '左机燃油进机压力', unit: 'KPa' },
    'lefla': { name: '左机燃油泄露报警', unit: '次' },
    'leloipa': { name: '左机滑油进机压力报警', unit: '次' },
    'leloip': { name: '左机滑油进机压力', unit: 'KPa' },
    'leloipp': { name: '左机滑油进机压力停车', unit: '次' },
    'leloit': { name: '左机滑油进机温度', unit: '°C' },
    'leloita': { name: '左机滑油进机温度报警', unit: '次' },
    'lesa': { name: '左机转速报警', unit: '次' },
    'lesp': { name: '左机转速停车', unit: '次' },
    'lfwip': { name: '左机淡水进机压力', unit: 'KPa' },
    'lfwot': { name: '左机淡水出机温度', unit: '°C' },
    'lfwota': { name: '左机淡水出机温度报警', unit: '次' },
    'lmcai': { name: '左机综合报警指示', unit: '次' },
    'lmcrp': { name: '左机共轨压力', unit: 'KPa' },
    'loth': { name: '左油舱高度', unit: 'cm' },
    'lts': { name: '左机增压器转速', unit: '转/分' },
    'noefotls': { name: '左机ECU故障数', unit: '次' },
    'nofitrue': { name: '右机ECU故障数', unit: '次' },
    'nopoditdc': { name: '驾驶室值班人数', unit: '人' },
    'rebap': { name: '右机增压空气压力', unit: 'KPa' },
    'rebat': { name: '右机增压空气温度', unit: '°C' },
    'reffop': { name: '右机滤前滑油压力', unit: 'KPa' },
    'refip': { name: '右机燃油进机压力', unit: 'KPa' },
    'refla': { name: '右机燃油泄露报警', unit: '次' },
    'reloip': { name: '右机滑油进机压力', unit: 'KPa' },
    'reloipa': { name: '右机滑油进机压力报警', unit: '次' },
    'reloips': { name: '右机滑油进机压力停车', unit: '次' },
    'reloit': { name: '右机滑油进机温度', unit: '°C' },
    'reloita': { name: '右机滑油进机温度报警', unit: '次' },
    'resa': { name: '右机转速报警', unit: '次' },
    'resp': { name: '右机转速停车', unit: '次' },
    'rfwip': { name: '右机淡水进机压力', unit: 'KPa' },
    'rfwot': { name: '右机淡水出机温度', unit: '°C' },
    'rfwota': { name: '右机淡水出机温度报警', unit: '次' },
    'rmbv': { name: '右机电瓶电压', unit: '伏特' },
    'rmcai': { name: '右机综合报警指示', unit: '次' },
    'rmcrp': { name: '右机共轨压力', unit: 'KPa' },
    'rts': { name: '右机增压器转速', unit: '转/分' },
    'shipPosition': { name: '船位', unit: '经纬度' },
    'tftnododitc': { name: '驾驶室值班人数阈值', unit: '人' },
    'toth': { name: '右油舱高度', unit: 'cm' }
};

function processShipData(data) {
    const processedDataItems = [];
    // 遍历data的所有键  
    Object.keys(data).forEach(key => {

        if (key in nameMapping) {
            const item = {
                name: nameMapping[key].name,
                value: data[key] || 0,
                unit: nameMapping[key].unit
            };
            processedDataItems.push(item);
        }
    });

    return processedDataItems;
}
export { processShipData };

// const nameMapping = {
//     abnormalReport: "异常上报",
//     cppm: "机舱巡查人员监测",
//     depthGauge: "机舱巡查人员监测",
//     fpblef: '左机滤前燃油压力',
//     fpbref: '右机滤前燃油压力',
//     hotrdot: '右日用油柜高度',
//     lbv: '左机电瓶电压',
//     ldoth: '左日用油柜高度',
//     lebap: '左机增压空气压力',
//     lebat: '左机增压空气温度',
//     lefflop: '左机滤前滑油压力',
//     lefip: '左机燃油进机压力',
//     lefla: '左机燃油泄露报警',
//     leloipa: '左机滑油进机压力报警',
//     leloip: '左机滑油进机压力',
//     leloipp: '左机滑油进机压力停车',
//     leloit: '左机滑油进机温度',
//     leloita: '左机滑油进机温度报警',
//     lesa: '左机转速报警',
//     lesp: '左机转速停车',
//     lfwip: '左机淡水进机压力',
//     lfwot: '左机淡水出机温度',
//     lfwota: '左机淡水出机温度报警',
//     lmcai: '左机综合报警指示',
//     lmcrp: '左机共轨压力',
//     loth: '左油舱高度',
//     lts: '左机增压器转速',
//     noefotls: '左机ECU故障数',
//     nofitrue: '右机ECU故障数',
//     nopoditdc: '驾驶室值班人数',
//     rebap: '右机增压空气压力',
//     rebat: '右机增压空气温度',
//     reffop: '右机滤前滑油压力',
//     refip: '右机燃油进机压力',
//     refla: '右机燃油泄露报警',
//     reloip: '右机滑油进机压力',
//     reloipa: '右机滑油进机压力报警',
//     reloips: '右机滑油进机压力停车',
//     reloit: '右机滑油进机温度',
//     reloita: '右机滑油进机温度报警',
//     resa: '右机转速报警',
//     resp: '右机转速停车',
//     rfwip: '右机淡水进机压力',
//     rfwot: '右机淡水出机温度',
//     rfwota: '右机淡水出机温度报警',
//     rmbv: '右机电瓶电压',
//     rmcai: '右机综合报警指示',
//     rmcrp: '右机共轨压力',
//     rts: '右机增压器转速',
//     shipPosition: '船位',
//     tftnododitc: '驾驶室值班人数阈值',
//     toth: '右油舱高度'
// };  
